/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Companystreet1Inputs */

const en_entity_companystreet1 = /** @type {(inputs: Entity_Companystreet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Street`)
};

const de_entity_companystreet1 = /** @type {(inputs: Entity_Companystreet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenstraße`)
};

/**
* | output |
* | --- |
* | "Company Street" |
*
* @param {Entity_Companystreet1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_companystreet1 = /** @type {((inputs?: Entity_Companystreet1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Companystreet1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_companystreet1(inputs)
	return de_entity_companystreet1(inputs)
});
export { entity_companystreet1 as "entity_companyStreet" }